import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { MaskLines } from "../components/site/Reveal";

const FAQ = [
  ["How long does shipping take?", "Orders are processed in 1–2 business days, and standard shipping takes an estimated 3–7 business days within the United States. Shipping is free on U.S. orders of $75 or more, and you'll get tracking information once your order ships."],
  ["What is your return policy?", "Eligible items may be returned within 30 days of delivery. They must be unused, unworn and in their original condition, with tags and packaging intact. Exchanges are subject to availability, and refunds go to the original payment method once the return is received and inspected. Email support to start a return or exchange."],
  ["Can the bag be worn crossbody?", "Yes. The adjustable strap lets you wear it at the waist, across the chest, over the shoulder or low on the hip."],
  ["How do I track my order?", "Use the Track Order page with your order number and email address."],
];

const field = "w-full border-b border-line bg-transparent py-3 text-base text-ink outline-none transition-colors placeholder:text-graphite focus:border-ink";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", order_number: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent. We'll be in touch soon.");
      setForm({ name: "", email: "", order_number: "", message: "" });
    } catch {
      toast.error("Please check your details and try again.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="bg-ivory pb-24 pt-36 md:pt-44" data-testid="contact-page">
      <div className="mx-auto grid max-w-[1600px] gap-16 px-5 md:px-10 lg:grid-cols-2">
        <div>
          <p className="label-mono">Customer care</p>
          <MaskLines as="h1" lines={["We're here", <em key="h">to help.</em>]} className="mt-3 font-display text-5xl font-light leading-[0.95] text-ink md:text-7xl" />
          <div className="mt-10 space-y-2 text-sm text-graphite">
            <p>Email support: <a href="mailto:support@shopmarkhor.com" className="link-line text-ink" data-testid="contact-support-email">support@shopmarkhor.com</a></p>
          </div>
          <div id="faq" className="mt-14 scroll-mt-32">
            <p className="label-mono mb-4">FAQ</p>
            <Accordion type="single" collapsible className="border-t border-line">
              {FAQ.map(([q, a], i) => (
                <AccordionItem key={q} value={`f${i}`} className="border-line">
                  <AccordionTrigger className="py-5 text-left text-sm text-ink hover:no-underline" data-testid={`faq-${i}`}>{q}</AccordionTrigger>
                  <AccordionContent className="text-sm text-graphite">{a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-6 self-start bg-white p-6 md:p-10" data-testid="contact-form">
          <input required placeholder="Name" value={form.name} onChange={set("name")} className={field} data-testid="contact-name-input" />
          <input required type="email" placeholder="Email" value={form.email} onChange={set("email")} className={field} data-testid="contact-email-input" />
          <input placeholder="Order number (optional)" value={form.order_number} onChange={set("order_number")} className={field} data-testid="contact-order-input" />
          <textarea required rows={5} placeholder="How can we help?" value={form.message} onChange={set("message")} className={field} data-testid="contact-message-input" />
          <button disabled={busy} className="btn-dark w-full" data-testid="contact-submit-button">{busy ? "Sending…" : "Send message"}</button>
        </form>
      </div>
    </div>
  );
}
